import React, { useEffect, useState } from "react";
import Sections from "./Sections";
const EditProfileDonor = ({
   isEditMode,
   values,
   handleChange,
   countryList,
   setFieldValue,
   errors,
   touched
}) => {
   const [selectedCountry, setSelectedCountry] = useState(values?.baseCountryId);
   useEffect(() => {
      setSelectedCountry(values?.baseCountryId);
   }, [values]);

   const getCountryName = (id) => {
      const countryName = countryList?.find((country) => country?.value === id);
      return countryName ? countryName?.label : "";
   };

   const handleCountrySelect = (selectedOption) => {
      setSelectedCountry(selectedOption.value);
      setFieldValue("baseCountryId", selectedOption.value);
   };

   const fields = [
      {
         sectionName: "Personal information",
         propertyName: "Name",
         name: "name",
         propertyValue: values?.name,
         isEditMode: isEditMode,
         handleChange: handleChange,
         isRequired: true
      },
      {
         sectionName: "Location",
         propertyName: "Base country",
         name: "baseCountryId",
         fieldType: "selectBaseCountry",
         propertyValue: isEditMode ? selectedCountry : getCountryName(selectedCountry),
         isEditMode: isEditMode,
         handleChange: handleChange,
         options: countryList,
         onSelectChange: handleCountrySelect,
         isRequired: true
      }
   ];

   return (
      <>
         {fields?.map((section, index) => (
            <div key={index}>
               <Sections {...section} />
               {errors[section.name] && touched[section.name] && (
                  <div className="text-danger">{errors[section.name]}</div>
               )}
            </div>
         ))}
      </>
   );
};

export default EditProfileDonor;
